import { Injectable } from '@angular/core';
import {Http, RequestOptions} from "@angular/http";

@Injectable()
export class ShortUrlService {
  private headers: any;
  private options: any;

  shortLinkStats: any;
  shortLinkUrl: any;

  ///

  stats: any;
  statsByShortLink = {};
  statsArray = [];

  totalShortUrls: number = 0;
  totalClicks: number = 0;
  clickIndexes = [];

  ///

  constructor(
    private http: Http
  ) { }

  generateShortUrl(url) {
    this.headers = new Headers({
      "Content-Type": "application/json",
      "Accept": "application/json",
    });
    this.options = new RequestOptions({headers: this.headers});
    return this.http.post('https://pug.gl/api/shorten/', {
      "url": url,
      "source": "admin.storagepug"
    }, this.options).map((res) => res.json());
  }

  getStatsByUrl(url) {
    this.headers = new Headers({
      "Content-Type": "application/json",
      "Accept": "application/json",
    });
    this.options = new RequestOptions({headers: this.headers});
    return this.http.get(url+'/stats', this.options).map((res) => res.json());
  }

  getStats() {
    this.headers = new Headers({
      "Content-Type": "application/json",
      "Accept": "application/json",
    });
    this.options = new RequestOptions({headers: this.headers});
    return this.http.post('https://pug.gl/api/stats', {
      "source": "admin.storagepug"
    }, this.options).map((res) => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/providers/short-url.service.ts